import React, { useEffect, useState } from 'react';
import { snoozeOverdue } from '../../lib/api';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { toast } from 'sonner';

const PRESETS = [
    { hours: 24, label: '+1 jour' },
    { hours: 72, label: '+3 jours' },
    { hours: 168, label: '+7 jours' },
    { hours: -1, label: 'Traité (marquer lu)' }
];

export const SnoozeDialog = ({ open, onOpenChange, entity, onDone }) => {
    const [selectedHours, setSelectedHours] = useState(24);
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        if (open) setSelectedHours(24);
    }, [open]);

    if (!entity) return null;

    const handleConfirm = async () => {
        setBusy(true);
        try {
            await snoozeOverdue(entity.type, entity.id, selectedHours);
            toast.success(selectedHours < 0 ? 'Marqué comme traité' : 'Reporté');
            onOpenChange(false);
            onDone && onDone();
        } catch (e) {
            toast.error(e.response?.data?.detail || 'Erreur');
        } finally {
            setBusy(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent data-testid="snooze-dialog">
                <DialogHeader>
                    <DialogTitle>Reporter ou traiter</DialogTitle>
                </DialogHeader>
                <div className="space-y-3">
                    <Label className="field-label">Choisissez une durée</Label>
                    <div className="grid grid-cols-2 gap-2">
                        {PRESETS.map((p) => (
                            <button
                                key={p.hours}
                                onClick={() => setSelectedHours(p.hours)}
                                className={`h-10 rounded-sm text-sm border transition-colors ${
                                    selectedHours === p.hours
                                        ? 'bg-[#E85A24] text-white border-[#E85A24]'
                                        : 'bg-white text-[#0A0A0A] border-[#E4E4E7] hover:border-[#E85A24]'
                                }`}
                                data-testid={`snooze-preset-${p.hours}`}
                            >
                                {p.label}
                            </button>
                        ))}
                    </div>
                    <p className="text-xs text-[#52525B]">
                        {selectedHours < 0
                            ? 'L\'item disparaîtra de la liste tant que la condition est résolue.'
                            : `Sera à nouveau visible après ${selectedHours}h.`}
                    </p>
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
                    <Button
                        onClick={handleConfirm}
                        disabled={busy}
                        className="bg-[#E85A24] hover:bg-[#CC4D1C] text-white rounded-sm"
                        data-testid="snooze-confirm-btn"
                    >
                        Confirmer
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
